'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M31.62 38.232a2.069 2.069 0 1 1 0-4.137 2.069 2.069 0 0 1 0 4.137Zm1.035 1.922a4.138 4.138 0 1 0-2.068 0V51.68h2.068v-2.069h2.069v-2.069h-2.07v-2.069h2.07v-2.069h-2.07v-3.25Zm11.38 1.682-.005.362a14.482 14.482 0 0 1-6.444 11.688l-5.965 3.977-5.965-3.977-.3-.204a14.486 14.486 0 0 1-6.15-11.846v-8.801l12.415-4.138 12.414 4.138v8.801ZM23.34 14.42l.01-.3a8.286 8.286 0 0 1 2.62-5.75 8.269 8.269 0 0 1 11.3 0c1.6 1.5 2.54 3.56 2.62 5.75l.01.3v10.339H23.34V14.42Zm22.9 10.339h-2.21V14.42C44.03 7.56 38.48 2 31.62 2S19.21 7.56 19.21 14.42v10.339H17c-2.2 0-4 1.8-4 4v29.242c0 2.2 1.8 4 4 4h29.242c2.2 0 4-1.8 4-4V28.759c0-2.2-1.8-4-4-4Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
});
var Encryption = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.Encryption = Encryption;